import { render, staticRenderFns } from "./SolicitarTransferencia.vue?vue&type=template&id=455bffdb&"
import script from "./SolicitarTransferencia.vue?vue&type=script&lang=js&"
export * from "./SolicitarTransferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports